var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleveryNotDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 37,
    viewBox: "0 0 48 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008885"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250849",
    d: "M1 20L24 1L47 20",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250847",
    d: "M19 24H6V36H19V24Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250852",
    d: "M42 24H29V36H42V24Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250851",
    d: "M6 18.8281V35.9989H18.7742V23.9013H28.4516V35.9989H42V18.8281",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250850",
    d: "M32 7.80432V1H37V12",
    stroke: "#383434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleveryNotDone);
export default __webpack_public_path__ + "static/media/Delevery_notDone.e0c0113d461b0c2d20757f99972fc408.svg";
export { ForwardRef as ReactComponent };